import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './use-auth';

export function useModuleAccess(moduleCode: string) {
  const { activeCompany, profile, hasCompanyRole } = useAuth();

  return useQuery({
    queryKey: ['module-access', profile?.id, activeCompany?.id, moduleCode],
    queryFn: async () => {
      if (!profile?.id || !activeCompany?.id) {
        return { hasAccess: false, isAdmin: false };
      }

      // Company admins têm acesso a tudo
      const isAdmin = hasCompanyRole(activeCompany.id, 'company_admin');
      if (isAdmin) {
        return { hasAccess: true, isAdmin: true };
      }

      // Verificar se o usuário tem o módulo atribuído
      const { data, error } = await supabase
        .from('user_module_assignments')
        .select(`
          module_id,
          modules!inner (
            code,
            systems!inner (
              code
            )
          )
        `)
        .eq('user_id', profile.id)
        .eq('company_id', activeCompany.id);

      if (error) {
        console.error('Error checking module access:', error);
        return { hasAccess: false, isAdmin: false };
      }

      // Verificar se algum módulo corresponde ao código solicitado
      // Aceita tanto o código do sistema quanto do módulo
      const hasModuleAccess = data?.some((assignment: any) => {
        const systemCode = assignment.modules?.systems?.code;
        const modCode = assignment.modules?.code;
        return systemCode === moduleCode || modCode === moduleCode;
      });

      return { hasAccess: hasModuleAccess || false, isAdmin: false };
    },
    enabled: !!profile?.id && !!activeCompany?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
